/* eslint react/prop-types: off */
import {
  map,
  findIndex,
  get,
  isNil
} from 'lodash'
import {
  Card,
  ContentSectionBlock,
  Popup,
  Table
} from 'camino-react'
import React from 'react'

import { cloudhelpPost, cloudhelpPatch } from '../../../utilities/CloudHelp'
import parseTimeToEstimationTime from '../../../utilities/TaskTimeEstimation'

import Form from './Form'

class ProblemTasks extends React.Component {
  constructor (props) {
    super()

    const { newTask, tasks } = props
    this.state = {
      displayForm: false,
      formableTask: {
        assignee_id: newTask.assignee_id,
        taskable_id: newTask.taskable_id,
        taskable_type: newTask.taskable_type
      },
      loading: false,
      buttonDisabled: false,
      alert: {},
      tasks
    }
  }

  setTaskCompleted (task, completed) {
    const { currentUser } = this.props
    this.setState({
      loading: true,
      formableTask: Object.assign(task, { completed_at: completed ? new Date() : null, completer_id: currentUser.id })
    }, () => this.updateTask())
  }

  handleEdit (task) {
    this.setState({ formableTask: task, displayForm: true, action: 'edit' })
  }

  restoreOriginalFormState () {
    const { newTask } = this.props
    this.setState({
      formableTask: {
        assignee_id: newTask.assignee_id, taskable_id: newTask.taskable_id, taskable_type: newTask.taskable_type
      },
      displayForm: false,
      alert: {},
      action: 'new'
    })
  }

  handleResponseAction (loading = false, buttonDisabled = false, alert = {}) {
    this.setState({ loading, buttonDisabled, alert })
  }

  updateTaskField (field, value) {
    const { formableTask } = this.state
    const updatedFormableTask = formableTask
    updatedFormableTask[field] = value

    this.setState({ formableTask: updatedFormableTask })
  }

  overrideTaskState (task) {
    const { tasks } = this.state
    const { updateTasksState } = this.props
    const taskIndex = findIndex(tasks, originalTask => originalTask.id === task.id)

    if (taskIndex !== -1) {
      tasks[taskIndex] = task
    } else {
      tasks.push(task)
    }

    this.setState({ tasks }, () => updateTasksState(tasks))
  }

  createTask () {
    const { problem } = this.props
    const { formableTask } = this.state

    cloudhelpPost(`/api/problems/${problem.id}/tasks`, formableTask)
      .then(({ data }) => {
        this.handleResponseAction(false, false, { type: 'success', text: data.message })
        setTimeout(() => this.restoreOriginalFormState(), 1000)
        this.overrideTaskState(data.task)
      })
      .catch(({ data }) => {
        this.handleResponseAction(false, false, { type: 'success', text: data.message })
      })
  }

  updateTask () {
    const { problem } = this.props
    const { formableTask } = this.state

    cloudhelpPatch(`/api/problems/${problem.id}/tasks/${formableTask.id}`, formableTask)
      .then(({ data }) => {
        this.handleResponseAction(false, false, { type: 'success', text: data.message })
        setTimeout(() => this.restoreOriginalFormState(), 1000)
        this.overrideTaskState(data.task)
      })
      .catch(({ data }) => {
        this.handleResponseAction(false, false, { type: 'success', text: data.message })
      })
  }

  submitForm () {
    const { action, formableTask } = this.state
    const { start_at, due_at } = formableTask
    this.handleResponseAction(true, true, {})
    this.setState({
      formableTask: Object.assign(formableTask, { estimation_time: parseTimeToEstimationTime(start_at, due_at) })
    })

    if (action === 'edit') {
      this.updateTask()
    } else {
      this.createTask()
    }
  }

  render () {
    const { hidden, usersOptions, currentUser, policies, problem } = this.props
    const { displayForm, formableTask, tasks, action, buttonDisabled, loading, alert } = this.state
    const manageTasks = get(policies, 'problem.manageTasks')
    const columns = [
      {
        text: 'Completed',
        type: 'checkbox'
      },
      {
        text: 'Title',
        accessor: 'name',
        Cell: row => (
          <p style={{ margin: '0' }}>
            {row.value}
            <br />
            {row.original.description}
          </p>
        )
      },
      {
        text: 'Assigned To',
        accessor: 'assignee_name'
      },
      {
        text: 'Start',
        type: 'datetime_alt'
      },
      {
        text: 'End',
        type: 'datetime_alt'
      }, manageTasks && {
        text: 'Actions',
        accessor: 'action_ellipsis',
        type: 'action_ellipsis'
      }
    ]
    const data = map(tasks, task => ({
      ...task,
      completed: {
        value: !isNil(task.completed_at),
        onValue: completed => this.setTaskCompleted(task, completed),
        disabled: manageTasks ? false : (loading || task.assignee_id !== currentUser.id)
      },
      action_ellipsis: [
        { text: 'Edit', onClick: () => this.handleEdit(task) },
        {
          href: `/api/problems/${problem.id}/tasks/${task.id}`,
          method: 'DELETE',
          text: 'Delete',
          confirm: 'Are you sure?',
          color: 'red'
        }
      ]
    }))

    if (hidden) {
      return null
    }

    return (
      <Card allowOverflow padding={false}>
        <ContentSectionBlock
          title="Tasks"
          actions={manageTasks ? [
            {
              text: <div className="duration-300 hover:text-blue-700">Add Task</div>,
              onClick: () => this.setState({ displayForm: true })
            }
          ] : []}
        >
          <Table
            data={data}
            columns={columns}
            localStoragePrefix="ProblemShowTasks"
          />
        </ContentSectionBlock>

        <Popup
          modal
          open={displayForm}
          closeOnDocumentClick={false}
          contentStyle={{ borderRadius: 8 }}
        >
          <Form
            closeForm={() => this.setState({ displayForm: false })}
            updateTaskField={(field, value) => this.updateTaskField(field, value)}
            submitForm={() => this.submitForm()}
            formableTask={formableTask}
            {...{ usersOptions, action, buttonDisabled, loading, alert }}
          />
        </Popup>
      </Card>
    )
  }
}

export default ProblemTasks
